module.exports = __webpack_public_path__ + "img/avatar.945f33b6.png";